/** Paleta distinta com bom contraste em tema claro e escuro. */
export const MEMBER_COLOR_PALETTE = [
  {
    light: "hsl(262 75% 55%)",
    dark: "hsl(262 70% 70%)",
    badge: {
      light: { bg: "hsl(262 75% 55% / 0.14)", fg: "hsl(262 55% 36%)" },
      dark: { bg: "hsl(262 70% 70% / 0.2)", fg: "hsl(262 75% 85%)" },
    },
  },
  {
    light: "hsl(199 89% 48%)",
    dark: "hsl(199 80% 65%)",
    badge: {
      light: { bg: "hsl(199 89% 48% / 0.14)", fg: "hsl(199 75% 32%)" },
      dark: { bg: "hsl(199 80% 65% / 0.2)", fg: "hsl(199 85% 82%)" },
    },
  },
  {
    light: "hsl(142 60% 38%)",
    dark: "hsl(142 55% 55%)",
    badge: {
      light: { bg: "hsl(142 60% 38% / 0.14)", fg: "hsl(142 55% 28%)" },
      dark: { bg: "hsl(142 55% 55% / 0.2)", fg: "hsl(142 60% 78%)" },
    },
  },
  {
    light: "hsl(38 92% 50%)",
    dark: "hsl(38 85% 58%)",
    badge: {
      light: { bg: "hsl(38 92% 50% / 0.16)", fg: "hsl(38 80% 32%)" },
      dark: { bg: "hsl(38 85% 58% / 0.2)", fg: "hsl(38 90% 80%)" },
    },
  },
  {
    light: "hsl(0 72% 51%)",
    dark: "hsl(0 62% 55%)",
    badge: {
      light: { bg: "hsl(0 72% 51% / 0.14)", fg: "hsl(0 65% 36%)" },
      dark: { bg: "hsl(0 62% 55% / 0.2)", fg: "hsl(0 70% 82%)" },
    },
  },
  {
    light: "hsl(280 65% 52%)",
    dark: "hsl(280 60% 68%)",
    badge: {
      light: { bg: "hsl(280 65% 52% / 0.14)", fg: "hsl(280 55% 36%)" },
      dark: { bg: "hsl(280 60% 68% / 0.2)", fg: "hsl(280 70% 84%)" },
    },
  },
  {
    light: "hsl(173 58% 39%)",
    dark: "hsl(173 50% 52%)",
    badge: {
      light: { bg: "hsl(173 58% 39% / 0.14)", fg: "hsl(173 55% 28%)" },
      dark: { bg: "hsl(173 50% 52% / 0.2)", fg: "hsl(173 55% 78%)" },
    },
  },
  {
    light: "hsl(24 95% 53%)",
    dark: "hsl(24 90% 62%)",
    badge: {
      light: { bg: "hsl(24 95% 53% / 0.14)", fg: "hsl(24 85% 34%)" },
      dark: { bg: "hsl(24 90% 62% / 0.2)", fg: "hsl(24 90% 82%)" },
    },
  },
] as const;

export type MemberBadgeColors = {
  light: { bg: string; fg: string };
  dark: { bg: string; fg: string };
};

function hashMemberId(memberId: string): number {
  let hash = 0;
  for (let i = 0; i < memberId.length; i++) {
    hash = (hash * 31 + memberId.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function getMemberColorIndex(memberId: string): number {
  return hashMemberId(memberId) % MEMBER_COLOR_PALETTE.length;
}

export function memberColor(
  memberIdOrIndex: string | number,
  mode: "light" | "dark" = "dark",
): string {
  const index =
    typeof memberIdOrIndex === "string"
      ? getMemberColorIndex(memberIdOrIndex)
      : memberIdOrIndex % MEMBER_COLOR_PALETTE.length;
  return MEMBER_COLOR_PALETTE[index][mode];
}

export function getMemberBadgeColors(memberId: string): MemberBadgeColors {
  const palette = MEMBER_COLOR_PALETTE[getMemberColorIndex(memberId)];
  return palette.badge;
}
